import { render, staticRenderFns } from "./BrosurList.vue?vue&type=template&id=2d091cde"
import script from "./BrosurList.vue?vue&type=script&lang=js"
export * from "./BrosurList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports